{
  "name": "artaah-customer-portal",
  "version": "2.0.0",
  "private": true,
  "scripts": {
    "ng": "ng",
    "build": "npm run env -s && ng build --configuration production",
    "start": "npm run env -s && ng serve --proxy-config proxy.conf.js --port 4200",
    "deploy": "npm run env -s && ng deploy",
    "publish": "npm run build && npm run deploy",
    "serve:sw": "npm run build -s && npx http-server ./dist -p 4200",
    "lint": "ng lint && stylelint \"src/**/*.scss\"",
    "test": "npm run env -s && ng test",
    "test:ci": "npm run env -s && npm run lint -s && ng test --configuration=ci",
    "translations:extract": "ngx-translate-extract --input ./src --output ./src/translations/template.json --format=json --clean --sort --marker extract",
    "docs": "npx serve ./docs",
    "compodoc": "compodoc -p tsconfig.app.json -d docs/generated -s -o",
    "env": "ngx-scripts env npm_package_version",
    "prettier": "prettier --write \"./{src,e2e}/**/*.{ts,js,html,scss}\"",
    "prettier:check": "prettier --list-different \"./{src,e2e}/**/*.{ts,js,html,scss}\"",
    "postinstall": "npm run prettier -s",
    "generate": "ng generate",
    "start:dev": "npm run env -s && ng serve --hmr --configuration dev --host 0.0.0.0 --port 4200",
    "start:development": "npm run env -s && ng serve --configuration development --port 4200",
    "start:local": "npm run env -s && ng serve --configuration local --host 0.0.0.0 --port 4200",
    "start:sgs-development": "npm run env -s && ng serve --configuration sgs-development --port 4200",
    "start:staging": "npm run env -s && ng serve --configuration staging --port 4200",
    "start:sgs-production": "npm run env -s && ng serve --configuration sgs-production --port 4200",
    "build:development": "npm run env -s && ng build --configuration development",
    "build:sgs-development": "npm run env -s && ng build --configuration sgs-development && node scripts/sgs-post-build.js",
    "build:staging": "npm run env -s && ng build --configuration staging",
    "build:sgs-production": "npm run env -s && ng build --configuration sgs-production && node scripts/sgs-post-build.js"
  },
  "dependencies": {
    "@angular/animations": "^19.2.21",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.21",
    "@angular/compiler": "^19.2.21",
    "@angular/core": "^19.2.21",
    "@angular/fire": "19.2.0",
    "@angular/forms": "^19.2.21",
    "@angular/localize": "^19.2.21",
    "@angular/material": "^19.2.19",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.21",
    "@angular/platform-browser-dynamic": "^19.2.21",
    "@angular/router": "^19.2.21",
    "@angular/service-worker": "^19.2.21",
    "@microsoft/signalr": "^6.0.11",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ngx-translate/core": "^16.0.4",
    "@popperjs/core": "^2.11.8",
    "@types/googlemaps": "^3.43.3",
    "angularx-qrcode": "^15.0.0",
    "bootstrap": "^5.3.2",
    "chart.js": "^4.5.1",
    "firebase": "^11.8.0",
    "google-libphonenumber": "^3.2.44",
    "html5-qrcode": "^2.3.8",
    "lodash": "^4.17.21",
    "material-design-icons-iconfont": "^5.0.1",
    "moment": "^2.29.4",
    "msal": "^1.4.8",
    "ng-otp-input": "^1.9.3",
    "ng2-charts": "^6.0.1",
    "ngx-infinite-scroll": "^14.0.0",
    "progress-tracker": "^2.0.6",
    "rxjs": "^7.8.1",
    "sweetalert2": "^11.4.32",
    "tslib": "^2.6.2",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^19.0.1",
    "@angular-devkit/architect": "^0.1902.25",
    "@angular-devkit/build-angular": "^19.2.25",
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/cli": "^19.2.25",
    "@angular/compiler-cli": "^19.2.21",
    "@angular/language-service": "^19.2.21",
    "@biesbjerg/ngx-translate-extract": "^7.0.4",
    "@compodoc/compodoc": "^1.1.22",
    "@ngx-rocket/scripts": "^4.0.0",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/jasmine": "~3.10.5",
    "@types/jasminewd2": "^2.0.10",
    "@types/jest": "^29.5.11",
    "@types/lodash": "^4.14.202",
    "@types/node": "^18.19.20",
    "@typescript-eslint/eslint-plugin": "^8.59.2",
    "@typescript-eslint/parser": "^8.59.2",
    "angular-eslint": "^19.8.1",
    "eslint": "^9.39.4",
    "fuzzy": "^0.1.3",
    "htmlhint": "^1.1.4",
    "https-proxy-agent": "^7.0.2",
    "husky": "^4.2.3",
    "inquirer": "^9.2.16",
    "inquirer-autocomplete-prompt": "^1.4.0",
    "jasmine-core": "~4.6.0",
    "jasmine-spec-reporter": "~7.0.0",
    "jest": "^29.7.0",
    "open": "^9.1.0",
    "prettier": "^3.5.3",
    "pretty-quick": "^4.1.1",
    "puppeteer": "^22.5.0",
    "semantic-release": "^22.0.10",
    "stylelint": "^15.11.0",
    "stylelint-config-prettier": "^9.0.5",
    "stylelint-config-recommended-scss": "^13.1.0",
    "stylelint-config-standard": "^34.0.0",
    "stylelint-scss": "^5.2.1",
    "ts-node": "^10.9.2",
    "typescript": "~5.8.3",
    "typescript-eslint": "^8.62.1"
  },
  "prettier": {
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.scss",
        "options": {
          "singleQuote": false
        }
      }
    ]
  },
  "husky": {
    "hooks": {
      "pre-commit": "pretty-quick --staged"
    }
  },
  "overrides": {
    "tough-cookie": ">=6.0.1",
    "qs": ">=6.13.0",
    "ip-address": ">=9.0.5",
    "brace-expansion": ">=2.0.1",
    "picomatch": ">=4.0.0",
    "semver": ">=7.5.2",
    "yaml": ">=2.3.2",
    "minimatch": ">=9.0.5",
    "axios": ">=1.8.2"
  }
}
